// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1TH-M","selected":"Chip_selected__3UIaw"};